/**
 * Clean 404 page. Red "404", black headline, white surface -- palette on point.
 */
import * as React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-3xl px-4 md:px-8 py-24 text-center">
      <p className="font-display text-[120px] leading-none font-black text-brand mb-6">404</p>
      <h1 className="text-3xl md:text-4xl font-black mb-3">This page didn’t dock here.</h1>
      <p className="text-ink-muted max-w-lg mx-auto mb-8">
        The link may be stale, or this feature ships in a later phase. Try heading back to the marketplace.
      </p>
      <Link to="/" data-testid="notfound-home-link">
        <Button variant="primary" size="lg">Return to the marketplace</Button>
      </Link>
    </div>
  );
}
